import { useTheme, Theme } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";
import { PropsAdronIcon } from "../../../_app/types";

const Profile = ({ size, colorCustom }: PropsAdronIcon) => {
  const theme: Theme = useTheme();
  return (
    <SvgIcon
      viewBox={size ? `0 0 ${size} ${size}` : undefined}
      style={size ? { width: size, height: size } : undefined}
    >
      <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.99609 15.9998C1.99609 8.19674 8.32174 1.87109 16.1248 1.87109C23.9278 1.87109 30.2536 8.19674 30.2536 15.9998C30.2536 23.8027 23.9278 30.1285 16.1248 30.1285C8.32174 30.1285 1.99609 23.8027 1.99609 15.9998ZM16.1248 3.89775C9.44103 3.89775 4.02275 9.31603 4.02275 15.9998C4.02275 19.1402 5.21898 22.0013 7.18064 24.1522C9.06538 21.2079 12.3666 19.2534 16.1256 19.2534C19.8842 19.2534 23.185 21.2075 25.07 24.1511C27.0309 22.0005 28.2269 19.1397 28.2269 15.9998C28.2269 9.31603 22.8084 3.89775 16.1248 3.89775ZM23.553 25.5546C22.0641 22.9963 19.2946 21.28 16.1256 21.28C12.9562 21.28 10.1864 22.9968 8.69782 25.5555C10.7481 27.1514 13.3255 28.1018 16.1248 28.1018C18.9246 28.1018 21.5024 27.151 23.553 25.5546ZM11.1118 13.8771C11.1118 11.1083 13.3563 8.86379 16.1251 8.86379C18.8939 8.86379 21.1384 11.1083 21.1384 13.8771C21.1384 16.6459 18.8939 18.8905 16.1251 18.8905C13.3563 18.8905 11.1118 16.6459 11.1118 13.8771ZM16.1251 10.8905C14.4756 10.8905 13.1384 12.2276 13.1384 13.8771C13.1384 15.5266 14.4756 16.8638 16.1251 16.8638C17.7746 16.8638 19.1118 15.5266 19.1118 13.8771C19.1118 12.2276 17.7746 10.8905 16.1251 10.8905Z"
          fill={colorCustom ? colorCustom : theme.palette.text.primary}
        />
      </svg>
    </SvgIcon>
  );
};

export default Profile;
